<script>
	export let copySource
    let HeroBG = 'https://points-ebgt.s3.amazonaws.com/marriott/promotions/2024/Jan/2024_PointsMDG_EG_1440x480_D.jpg'
    let PromoBG = 'https://points-ebgt.s3.us-east-1.amazonaws.com/marriott/promotions/2026/April/MDG_FINAL/EN/PointsMDG_2048x683_D_EN.jpg'  
</script>

<style>
/* .hero#landing-ch, .hero#landing-jp, .hero#landing-en{
    background-image: url('https://points-ebgt.s3.amazonaws.com/marriott/promotions/2024/Jan/2024_PointsMDG_EG_1440x480_D.jpg') !important;
    background-position: 65% bottom;
    height: 580px;
}  */
 #landing-en, #landing-ch, #landing-jp, #landing-de {
        display: none;
    } 
.hero#landing-en{
    background-image: url('https://points-ebgt.s3.us-east-1.amazonaws.com/marriott/promotions/2026/April/MDG_FINAL/EN/PointsMDG_2048x683_D_EN.jpg') !important;
    background-position: 65% bottom;
    height: 580px;
}
.hero {
        position: relative;
        width: 100%;
		margin: auto;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: 90% bottom;
        height: 480px;
        min-height: 200px;
        transition: .5s ease-in-out all;

	}
    .hero:lang(ja)::before, .hero:lang(zh-hans)::before{
        background: none;
    }
    .hero#landing-jp > div > h1 > .headline-two,  .hero#landing-jp > div > .headline-one{
        font-family: 'KozukaMincho-regular', serif;
        font-style: normal ;
        display: block;
    }
    .hero#landing-ch > div > h1 > .headline-two, .hero#landing-ch > div > .headline-one {
        font-family: 'NotoSerif-regular', serif;
        font-style: normal ;
        display: block;
    }
    .hero::before {
        content: '';
        position:absolute;
        display: inline-block;
        height: 100%;
        width: 100%;
        background: linear-gradient(280deg, rgba(0,0,0,0.8113620448179272) 0%, rgba(0,0,0,0.0018382352941176405) 70%);
    }
    .hero#landing-ch::before, .hero#landing-jp::before {
        content: '';
        position:absolute;
        display: inline-block;
        height: 100%;
        width: 100%;
        background: linear-gradient(280deg, rgba(0,0,0,0.8113620448179272) 0%, rgba(0,0,0,0.0018382352941176405) 80%);
    }
    .hero > div {
        position: absolute;
        display: block;
        right: 5%;
        top: 33%;
        padding-left: 40px;
        max-width: 525px;
        text-align: left;
        color: #fff;
        transition: .5s ease-in-out all;
    }
    .hero > div:lang(de){
        right: 10%;
        top: 27%;
    }
    .hero > div:lang(fr){
        max-width: 480px;
        right: 6%;
        top: 21%;
    }
    .hero > div:lang(es){
        /* max-width: 390px; */
        right: 10%;
        top: 27%;
    }
     .hero > div:lang(it){
        /* max-width: 390px; */
        max-width: none;
        right: 6%;
        top: 28%;
    }
    .hero > div:lang(pt){
        top: 30%;
        right: 10%;
    }
    .hero > div:lang(ja), .hero > div:lang(zh-hans) {
        color: #fff;
    }
    .hero > div:lang(ja){
        right: 7%;
    }
    .hero > div > h1 {
        display: block;
        font-size: 42px;
        font-family: 'Swiss721 Regular';
        font-weight: normal;
        margin: 5px 0;
        white-space: pre-line;
        /* width: 75%;
        max-width: 580px; */
        transition: .5s ease-in-out all;
    }
    .hero > div > h1:lang(ja){
        /* width: 78%; */
        line-height: 1.2em;
    }
    .hero > div > .headline-one {
        font-family: 'aldine-light', serif;
        font-weight: normal;
        font-size: 36px;
    }
    .hero > div > h1 > .headline-two {
        font-family: 'Aldine Light Italic', serif;
        font-style: normal;
        display: block;
    }
    
    .hero > div > p {
        font-family: 'Swiss721 Regular';
        font-weight: normal;
        display: inline-block;
        /* width: 85%; */
        white-space: pre-line;
        font-size: 18px;
        margin: 5px 0;
        transition: .5s ease-in-out all;
    }
    .hero > div > p:lang(ja) {
        font-size: 18px;
        line-height: 1.5em;
        font-family: 'KozukaGothic-regular';
    }
    .hero > div > p:lang(zh-hans) {
        font-size: 18px;
        font-family: 'NotoSans-regular';
        
    }
    @media only screen and (max-width: 1200px) {
        .hero > div  , .hero > div:lang(ja) {
        
        right: 0%;
    }
    .hero > div:lang(es){
        max-width: 360px;
        
    }
    .hero > div > p:lang(es) {
        width: 96%;
    }
    .hero > div:lang(it){
        max-width: 390px;
        
    }
    .hero > div:lang(de){
        right: 5%;
    }
    .hero > div > p {
        width: 85%;
        white-space: normal !important;
    }

    }
    @media only screen and (max-width: 1010px) {
        .hero{
           height: 390px; 
        }
        .hero > div {
       max-width: 425px;
    }
    .hero > div:lang(fr){
        max-width: 370px;
    }
    .hero > div:lang(pt){
        max-width: 270px;
        top: 12%;
    }
      .hero > div:lang(it){
        max-width: 320px;
    }
    .hero > div:lang(es){
        max-width: 265px;
        top: 12%;
    }
    .hero > div > .headline-one, .hero > div > h1 > .headline-two {
        font-size: 28px;
    }
    .hero > div > p {
        font-size: 16px;
       
    }
    /* .hero > div > p:lang(es), .hero > div > p:lang(fr), .hero > div > p:lang(it) {
        font-size: 15px;
       
    } */
    .hero#landing-ch, .hero#landing-jp{
        height: 400px;
        background-position: 50% bottom;
    }
    .hero > div > p:lang(ja),  .hero > div > p:lang(zh-hans) {
        max-width: 400px;
    }
    .hero#landing-jp > div:lang(ja){
            top: 14%;
            /* max-width: 300px; */
        }
    }

    @media only screen and (max-width: 830px) {
        .hero{
            height: 400px !important;
            background-position: 56% top;
        }
        .hero::before {
        content: '';
        position:absolute;
        display: inline-block;
        height: 100%;
        width: 100%;
        background: linear-gradient(280deg, rgba(0,0,0,0.8113620448179272) 0%, rgba(0,0,0,0.0018382352941176405) 80%);
    }
    .hero > div > .headline-one, .hero > div > h1 > .headline-two {
        font-size: 25px;
    }
        .hero > div{
            max-width: 375px;
        }
         .hero > div:lang(it){
            max-width: 280px;
        }
        .hero > div:lang(fr){
        max-width: 330px;
    }
        .hero > div > h1 > .headline-two {
            display: inline-block;
        }
        .hero#landing-ch, .hero#landing-jp{
        height: 400px;
        background-position: 60% bottom;
    }
    .hero > div:lang(es) {
            max-width: 270px;
            right: 5%;
            top: 10%;
    }
    .hero > div > p{
        width: 85%;
    }
    .hero > div > p:lang(de){
        font-size: 17px;
    }
    .hero > div > h1:lang(zh-hans){
            font-size: 26px;
            max-width: 480px;
        }
        .hero > div > h1:lang(ja){
            font-size: 26px;
            max-width: 480px;
        }
        .hero > div > p:lang(ja),  .hero > div > p:lang(zh-hans) {
        max-width: 330px;
    }
    }

    @media only screen and (max-width: 650px) {
        .hero, .hero#landing-ch, .hero#landing-jp {
            background-position: 50% bottom;
            height: 280px !important;
        }
        .hero > div {
            text-shadow: 0px 0px 12px #1c1c1c;
            max-width: 280px;
            top: 25%;
        }
        .hero > div:lang(de){
            top: 22%;
        }
        .hero > div:lang(es){
            width: 225px;
            top: 7%;
            right: 0%;
        }
        .hero > div:lang(it){
            top: 18%;
            right: 0%;
            max-width: 240px;
        }
        .hero > div > .headline-one, .hero > div > h1 > .headline-two {
            font-size: 20px;
        }
        .hero > div:lang(fr){
        max-width: 270px;
    }
        .hero > div > h1:lang(es),  .hero > div > h1:lang(fr) {
            font-size: 20px;
        }
        
        

        .hero > div > h1:lang(pt) {
        font-size: 20px;
        }
        .hero > div:lang(pt){
        width: 192px;
        top: 8%;
    }
        .hero > div > p, .hero > div > p:lang(es), .hero > div > p:lang(de) {
            font-size: 12px;
        }
        .hero#landing-jp > div:lang(ja){
            top: 12%;
        }
        .hero > div > h1:lang(zh-hans), .hero > div > h1:lang(ja) {
            font-size: 20px;
            max-width: 300px;
            width: 90%;
        }
        .hero > div > p:lang(ja), .hero > div > p:lang(zh-hans){
            font-size: 12px;
            max-width: 250px;
        }
    }

    @media only screen and (max-width: 500px) {
        .hero > div:lang(pt){
        
        top: 5%;
    }
        .hero{
            height: 250px !important;
                background-position: 45% bottom !important;
        }
        .hero#landing-ch, .hero#landing-jp {
            background-position: 50% bottom;
            height: 250px !important;  
        }
        
        .hero > div > h1:lang(zh-hans), .hero > div > h1:lang(ja) {
            font-size: 20px;
            max-width: 300px;
        }
        .hero > div:lang(fr){
        max-width: 270px;
        top: 10%;
    }
        .hero > div > .headline-one {
            font-size: 20px;
            width: 90%;
        }
        .hero > div:lang(ja), .hero > div:lang(zh-hans) {
            padding-left: 15px;
           
    }
    
    .hero > div > p:lang(zh-hans), .hero > div > p:lang(ja){
        max-width: 250px !important;
        }
    }

    @media only screen and (max-width: 400px) {
        .hero#landing-ch, .hero#landing-jp {
            background-position: 45% bottom;
            
        }
        .hero > div > .headline-one:lang(de), .hero > div > h1 > .headline-two:lang(de) {
            font-size: 17px;
        }
        .hero > div > .headline-one:lang(fr), .hero > div > h1 > .headline-two:lang(fr) {
            font-size: 17px;
        }
        .hero > div:lang(de) {
            max-width: 235px;
            right: 0%;
    }
    
    .hero > div:lang(fr) {
            width: 220px;
            right: 0%;
    }
        .hero{
            background-position: 45% bottom;
        }
    .hero > div:lang(ja){
        max-width: 255px;
    }
        .hero > div {
            padding-left: 20px;
            max-width: 233px;
        }
        .hero > div > .headline-one:lang(fr) {
            font-size: 18px;
        }
        .hero > div > p {
            font-size: 12px;
        }
        .hero > div > p:lang(ja) {
            max-width: 215px;
        }
    }

 /* Prmo css start  */
 #promo-ch{
        background-image: url(https://points-ebgt.s3.us-east-1.amazonaws.com/marriott/promotions/2026/April/MDG_FINAL/CHS/PointsMDG_2048x683_D_CN.jpg) !important;
    }
    #promo-jp{
        background-image: url(https://points-ebgt.s3.us-east-1.amazonaws.com/marriott/promotions/2026/April/MDG_FINAL/JPN/PointsMDG_2048x683_D_JP.jpg) !important;
    }
    #promo-de{
        background-image: url(https://points-ebgt.s3.us-east-1.amazonaws.com/marriott/promotions/2026/April/MDG_FINAL/GER/PointsMDG_2048x683_D_DE.jpg) !important;
    }
    #promo-es{
        background-image: url(https://points-ebgt.s3.us-east-1.amazonaws.com/marriott/promotions/2026/April/MDG_FINAL/SPA/PointsMDG_2048x683_D_ES.jpg) !important;
    }

    #promo-fr{
        background-image: url(https://points-ebgt.s3.us-east-1.amazonaws.com/marriott/promotions/2026/April/MDG_FINAL/FRE/PointsMDG_2048x683_D_FR.jpg) !important;
    }

    #promo-it{
        background-image: url(https://points-ebgt.s3.us-east-1.amazonaws.com/marriott/promotions/2026/April/MDG_FINAL/ITA/PointsMDG_2048x683_D_IT.jpg) !important;
    }

    #promo-pt{
        background-image: url(https://points-ebgt.s3.us-east-1.amazonaws.com/marriott/promotions/2026/April/MDG_FINAL/POR/PointsMDG_2048x683_D_PT.jpg) !important;
    }
    .promo-hero {
        position: relative;
        width: 100%;
		margin: auto;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        max-height: 100% !important;
        height: 33vw;
        transition: .5s ease-in-out all;
    }

    @media only screen and (max-width: 500px) {
        .promo-hero{
            height: 40vw;
        }
         #promo-en{
            background-image: url(https://points-ebgt.s3.us-east-1.amazonaws.com/marriott/promotions/2026/April/MDG_FINAL/EN/PointsMDG_500x200_M_EN.jpg) !important;
        }
        #promo-ch{
        background-image: url(https://points-ebgt.s3.us-east-1.amazonaws.com/marriott/promotions/2026/April/MDG_FINAL/CHS/PointsMDG_500x200_M_CN.jpg) !important;
    }
    #promo-de{
            background-image: url(https://points-ebgt.s3.us-east-1.amazonaws.com/marriott/promotions/2026/April/MDG_FINAL/GER/PointsMDG_500x200_M_DE.jpg) !important;
        }
    #promo-jp{
        background-image: url(https://points-ebgt.s3.us-east-1.amazonaws.com/marriott/promotions/2026/April/MDG_FINAL/JPN/PointsMDG_500x200_M_JP.jpg) !important;
    }
    #promo-es{
        background-image: url(https://points-ebgt.s3.us-east-1.amazonaws.com/marriott/promotions/2026/April/MDG_FINAL/SPA/PointsMDG_500x200_M_ES.jpg) !important;
    }

    #promo-fr{
        background-image: url(https://points-ebgt.s3.us-east-1.amazonaws.com/marriott/promotions/2026/April/MDG_FINAL/FRE/PointsMDG_500x200_M_FR.jpg) !important;
    }

    #promo-it{
        background-image: url(https://points-ebgt.s3.us-east-1.amazonaws.com/marriott/promotions/2026/April/MDG_FINAL/ITA/PointsMDG_500x200_M_IT.jpg) !important;
    }

    #promo-pt{
        background-image: url(https://points-ebgt.s3.us-east-1.amazonaws.com/marriott/promotions/2026/April/MDG_FINAL/POR/PointsMDG_500x200_M_PT.jpg) !important;
    }
    }
   
    
   
    /* #promo-fr, #promo-it, #promo-pt {
        display: none;
    }  */
</style>
<!--Baseline Hero-->
<!-- <div class="hero" id={copySource.hero.lang} style="background-image: url('{ HeroBG }');">
    <span role="img" aria-label="{copySource.hero.alt}"> </span>
    <div>
         <h1 class="headline-one">{copySource.hero.headline.lineOne}<span class="headline-two">{copySource.hero.headline.lineTwo}</span></h1>
        <p id="hero-copy" >{copySource.hero.subHeadline}</p> 
    </div>
</div> -->
<!--Baseline hero end-->

<!--Promo Hero-->
 <div class="promo-hero" id={copySource.promo.hero.promoLang} style="background-image: url('{ PromoBG }');">
  <!-- <div class="promo-overlay">
        <div class="copy-con">
             <h1>{copySource.promo.hero.headline}</h1>
            <div class="subheadline">{copySource.promo.hero.subheadline}</div>
            <p>{copySource.promo.hero.body}</p>
        </div>
    </div>  -->
</div>
